import React from 'react';
import { Password, PasswordProps } from 'primereact/password';

export const PasswordMediumRegex = '^((?=.*[a-z])|(?=.*[A-Z])).{8,}$';
export const PasswordStrongRegex = '^((?=.*[a-z])|(?=.*[A-Z])).{15,}$';

export const mediumPasswordTest = new RegExp(PasswordMediumRegex);
export const strongPasswordTest = new RegExp(PasswordStrongRegex);

export const PasswordWrapper: React.FC<PasswordProps> = (
    {
        mediumRegex = PasswordMediumRegex,
        strongRegex = PasswordStrongRegex,
        ...props
    }) => {
    return (
        <Password
            mediumRegex={mediumRegex}
            strongRegex={strongRegex}
            {...props}
        />
    )
}
